import { Empty } from 'antd';
import { useTranslation } from 'react-i18next';

import styles from './Empty.module.scss';

export const PageEmpty = () => {
    const { t } = useTranslation(['interface']);
    return (
        <Empty
            className={styles.page}
            image={''}
            description={t<string>('tip.page_not_found', { ns: 'interface' })}
        ></Empty>
    );
};
